<template >
  <sequential-entrance fromBottom>
    <v-row>
      <v-col>
        <div
          class="headline font-weight-light mb-2"
          style="color: #fff; text-align: left"
        >
          New Leads
        </div>
      </v-col>
      <v-col>
        <div
          class="headline font-weight-light mb-2"
          style="color: #78b59c; text-align: right"
        >
          22,361
        </div>
      </v-col>
    </v-row>
    <v-divider class="my-2"></v-divider>

    <bar-chart :height="300" ref="barChart" :chart-data="redBarChart.chartData">
    </bar-chart>
  </sequential-entrance>
</template>



<script>
import BarChart from "@/components/Charts/BarChart";
export default {
  components: {
    BarChart,
  },
  data() {
    return {
      redBarChart: {
        chartData: {
          labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          datasets: [
            {
              label: "Sales",
              data: [
                1212,
                2040,
                3450,
                2142,
                2434,
                2985,
                2756,
                2425,
                4214,
                2751,
                2415,
                2245,
              ],
            },
          ],
        },
      },
    };
  },
  methods: {
    initBigChart(index) {
      let chartData = {
        datasets: [
          {
            label: "Performance",
            data: this.bigLineChart.allData[index],
          },
        ],
        labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      };
      this.bigLineChart.chartData = chartData;
      this.bigLineChart.activeIndex = index;
    },
  },
  mounted() {
    this.initBigChart(0);
  },
};
</script>


<style scoped>
</style>